<template>
  <!--6 病例实战 -->
  <div class="case-section" @click="go(dataItem)">
    <img :src="dataItem.cover_img" class="case-section-img"/>
    <div class="case-section-content">
      <div class="case-section-content-title">{{ dataItem.title }}</div>
      <div class="case-section-content-detail" v-if="dataItem.type == 2">
        共{{ dataItem.total_count }}篇
        {{ dataItem.view_count }}人阅读
        <span class="case-section-content-detail-btn" v-if="dataItem.is_subscribe === 1"
              @click.stop="attention(dataItem)"
        >
          <img src="static/v4/icon_follow.svg" style="margin-right: 2px"/>关注
        </span>
        <span v-else class="case-section-content-detail-btn"
              @click.stop="attention(dataItem)">已关注</span>
      </div>
      <div class="case-section-content-detail" v-else>
        {{ dataItem.created_at | formateDate('Y-M-D h:m')}}
        {{ dataItem.view_count }}人观看
      </div>
    </div>
  </div>
</template>

<script>
import Interface from '@/util/interface'
export default {
  name: "case",
  props: {
    dataItem: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      // applyShow: false
    }
  },
  methods: {
    go(item) {
      Interface.goArticle(this, {
        id: item.origin_id,
        type: item.content.type,
      })
        Interface.mFootPrint(item.origin_id,6,0,5,0, item.title)
    },
    // 关注/未关注
    attention(item) {
      // is_subscribe 0 未关注  1 已关注
      if (item.is_subscribe == 0) {
        // 取消关注
        this.$dialog
            .confirm({
              title: '提醒',
              message: '确定取消关注吗？',
              confirmButtonText: '确定',
              className: 'dly-dialog'
            })
            .then(() => {
              Interface.getData('get', Interface.v4.attation + '/' + item.origin_id).then(res => {
                if (res.code == 0) {
                  this.$toast.success('取消关注成功')
                  item.is_subscribe = 1
                }
              })
            })
            .catch(() => {
              console.log(1)
            })
      } else {
        // 关注
        Interface.getData('get', Interface.v4.attation + '/' + item.origin_id).then(res => {
          if (res.code == 0) {
            this.$toast.success('关注成功')
            item.is_subscribe = 0
          }
        })
      }
    },
  }
}
</script>

<style scoped lang="scss">
.case-section{
  padding-bottom: 16px;
  &-img{
    width: 100%;
    height: 102px;
    background: linear-gradient(180deg, #ECEFF6 0%, #D7DFF3 100%);
    border-radius: 6px;
  }
  .van-image__img{
    width: 180px;
    height: 102px;
    border-radius: 6px;
  }
  &-content{
    height: 62px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding: 12px 0 0 0;
    &-title{
      font-size: 14px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #222222;
      line-height: 20px;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
    }
    &-detail{
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #979797;
      &-btn{
        font-size: 13px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #D81D20;
        padding: 3px 7px;
        background: #FFF0EE;
        border-radius: 17px;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/horizontalRecommend/case.vue